/* eslint-disable consistent-return */
import React from 'react';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { isSiteWithTelBanner } from '@panel/commons/helpers';
import { useTranslation } from 'react-i18next';
import calendarIcon from '@panel/commons/assets/icons/calendar.svg';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import TooltipHelp from '@panel/commons/assets/icons/tooltip-helper.svg';

const Title = ({ posting, device, onSharedDesempeno }) => {
  const { t } = useTranslation();
  const realestateType = posting.realestate_type;
  const { operationType } = posting;
  const location = posting.zone;
  const tooltipText = `${t('panel.desempeno.table.info')} ${realestateType} ${t(
    'panel.desempeno.table.info.en'
  )} ${operationType} ${t('panel.desempeno.table.info.en')} ${location}`;

  const tooltipTextComponent = <TooltipComponent>{tooltipText}</TooltipComponent>;

  return (
    <Container device={device} portalWithBanner={isSiteWithTelBanner} isSharedDesempeno={onSharedDesempeno}>
      <MainText>
        <h1 data-panel='performance-post-title'>{t('panel.desempeno.aviso.titulo')}</h1>
        {device !== 'mobile' ? (
          <DataInfo data-panel='performance-data'>{t('panel.desempeno.data')}</DataInfo>
        ) : (
          <SimpleTooltip
            offset={5}
            backgroundColor={select('black')}
            isMobile={false}
            text={tooltipTextComponent}
            position='bottom-center'
            dataPanel='info-performancePost'
            autoPlacements
          >
            <img src={TooltipHelp} alt='' width='16' height='16' />
          </SimpleTooltip>
        )}
      </MainText>
      {device === 'mobile' ? (
        <DataInfo>{t('panel.desempeno.data')}</DataInfo>
      ) : (
        <SubText data-panel='container-info'>
          {t('panel.desempeno.table.info')} <span data-panel='info-realestateType'>{realestateType}</span>
          {operationType && ` ${t('panel.desempeno.table.info.en')} `}
          <span data-panel='info-operationType'>{operationType}</span>
          {` ${t('panel.desempeno.table.info.en')} `}
          <span data-panel='info-location'>{location}</span>
        </SubText>
      )}
    </Container>
  );
};

export default Title;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ device }) => {
    switch (device) {
      case 'desktop':
        return '0px';
      case 'tablet':
        return '32px';
      case 'mobile':
        return '22px';
      default:
        return 0;
    }
  }};
  ${({ portalWithBanner, device, isSharedDesempeno }) => {
    if (device === 'tablet') {
      return css`
        margin-top: ${portalWithBanner ? 86 : 56}px;
      `;
    }
    if (device === 'mobile' && isSharedDesempeno) {
      return css`
        margin-top: ${portalWithBanner ? 122 : 92}px;
      `;
    }
    if (device === 'mobile') {
      return css`
        margin-top: ${portalWithBanner ? 86 : 56}px;
      `;
    }
  }};
`;

const MainText = styled.div`
  display: flex;
  align-items: center;
  > h1 {
    font-family: Hind;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 31px;
    letter-spacing: 0em;
    margin-right: 12px;
    margin-bottom: 1px;
  }
  img {
    margin-top: 6px;
  }
`;

const DataInfo = styled.div`
  display: flex;
  align-items: center;
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  color: ${select('darkGray')};
  :before {
    content: '';
    display: inline-block;
    background-image: ${`url(${calendarIcon})`};
    background-size: contain;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    position: relative;
    top: -2px;
  }
`;

const SubText = styled.div`
  display: flex;
  align-items: center;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: ${select('darkGray')};
  white-space: break-spaces;
  > span {
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: black;
  }
`;

const TooltipComponent = styled.div`
  max-width: 200px;
  white-space: pre-wrap;
  text-align: center;
  font-size: 14px;
`;
